import { render, staticRenderFns } from "./posFilterModal.vue?vue&type=template&id=06cf3025&"
import script from "./posFilterModal.vue?vue&type=script&lang=js&"
export * from "./posFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports